import { useTranslation } from 'react-i18next';
import { Briefcase } from 'lucide-react';

export const LuggageForm = ({ formData, setFormData }) => {
  const { t } = useTranslation();

  const updateLuggage = (field, value) => {
    setFormData(prev => ({ ...prev, luggage: { ...prev.luggage, [field]: value } }));
  };

  return (
    <div className="form-section" data-testid="luggage-section">
      <h2><Briefcase size={20} /> {t('createRide.sections.luggage')}</h2>
      <p className="section-description">{t('createRide.luggage.description')}</p>
      
      <div className="checkbox-group">
        <label className="checkbox-label">
          <input type="checkbox" checked={formData.luggage.hand_luggage} onChange={(e) => updateLuggage('hand_luggage', e.target.checked)} />
          <span>{t('createRide.luggage.handLuggage')}</span>
        </label>
        <label className="checkbox-label">
          <input type="checkbox" checked={formData.luggage.suitcase_allowed} onChange={(e) => updateLuggage('suitcase_allowed', e.target.checked)} />
          <span>{t('createRide.luggage.suitcase')}</span>
        </label>
        {formData.luggage.suitcase_allowed && (
          <div className="form-group inline">
            <label>{t('createRide.luggage.maxSuitcases')}</label>
            <input type="number" value={formData.luggage.suitcase_max} onChange={(e) => updateLuggage('suitcase_max', parseInt(e.target.value) || 1)} min="1" max="4" className="number-input-small" />
          </div>
        )}
        <label className="checkbox-label">
          <input type="checkbox" checked={formData.luggage.backpack} onChange={(e) => updateLuggage('backpack', e.target.checked)} />
          <span>{t('createRide.luggage.backpack')}</span>
        </label>
        <label className="checkbox-label">
          <input type="checkbox" checked={formData.luggage.bicycle_allowed} onChange={(e) => updateLuggage('bicycle_allowed', e.target.checked)} />
          <span>{t('createRide.luggage.bicycle')}</span>
        </label>
        <label className="checkbox-label">
          <input type="checkbox" checked={formData.luggage.ski_allowed} onChange={(e) => updateLuggage('ski_allowed', e.target.checked)} />
          <span>{t('createRide.luggage.ski')}</span>
        </label>
      </div>
    </div>
  );
};
